import { render, staticRenderFns } from "./VAcceptList.vue?vue&type=template&id=d3bc4aba&"
import script from "./VAcceptList.vue?vue&type=script&lang=ts&"
export * from "./VAcceptList.vue?vue&type=script&lang=ts&"
import style0 from "./VAcceptList.vue?vue&type=style&index=0&id=d3bc4aba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports